module.exports = __webpack_public_path__ + "static/media/NotoSansSC-Bold-Alphabetic.1e3a1045.woff2";